export default __webpack_public_path__ + "6f3dd19e9341fbe649601781deea64b1.woff2";